var render = function render(){var _vm=this,_c=_vm._self._c;return _c('minimal-bg-layout',[_c('the-header',{attrs:{"solo-logo":_vm.headerSoloLogo}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }